"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@mui/material");
var _base = require("@mui/base");
var _wouter = require("wouter");
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _common = require("../../store/common");
var _admin = require("../../store/admin");
var _materialEx = require("../../components/material-ex");
var _Style = require("../../style/Style");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const App = () => {
  const [, setLocation] = (0, _wouter.useLocation)();
  const {
    setIsLoading,
    setToastText,
    setToastOpen,
    sendUpdatePasswordMail
  } = (0, _common.useCommonStore)();
  const {
    admins,
    errors,
    fetchAdmins,
    deleteAdmin
  } = (0, _admin.useAdminStore)();
  (0, _react.useEffect)(() => {
    (async () => {
      setIsLoading(true);
      await fetchAdmins();
      setIsLoading(false);
    })();
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
    container: true,
    ...stylex.props(_Style.wrapper.main),
    spacing: 4,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
      container: true,
      ...stylex.props(_Style.wrapper.mainTitle),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        ...stylex.props(_Style.textStyle.h1),
        children: "\u7BA1\u7406\u8005\u7BA1\u7406"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_base.Button, {
        ...stylex.props(_Style.buttonStyle.primary),
        onClick: () => {
          setLocation('/admin/add');
        },
        children: "\u65B0\u3057\u3044\u7BA1\u7406\u8005\u3092\u8FFD\u52A0"
      })]
    }), admins.length > 0 ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialEx.TableContainer, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Table, {
        sx: {
          tableLayout: 'fixed'
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_material.TableHead, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_materialEx.TableRow, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialEx.TableHeaderCell, {
              children: "\u7BA1\u7406\u8005\u540D"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialEx.TableHeaderCell, {
              children: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialEx.TableHeaderCell, {
              children: "\u6709\u52B9\u30D5\u30E9\u30B0"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialEx.TableHeaderCell, {})]
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.TableBody, {
          children: admins.map(admin => {
            return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_materialEx.TableRow, {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialEx.TableCell, {
                children: admin.name
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialEx.TableCell, {
                children: admin.emailText
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialEx.TableCell, {
                children: admin.enableText
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialEx.TableCell, {
                isCenter: true,
                children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Stack, {
                  spacing: 2,
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_base.Button, {
                    ...stylex.props(_Style.buttonStyle.secondary),
                    onClick: () => {
                      setLocation('/admin/edit/' + admin.id);
                    },
                    children: "\u7BA1\u7406\u8005\u60C5\u5831\u5909\u66F4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_base.Button, {
                    ...stylex.props(_Style.buttonStyle.secondary),
                    onClick: () => {
                      setLocation('/admin/edit-email/' + admin.id);
                    },
                    children: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u5909\u66F4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_base.Button, {
                    ...stylex.props(_Style.buttonStyle.secondary),
                    onClick: async () => {
                      const result = window.confirm("ユーザーにパスワード再設定メールを送信してよろしいですか？");
                      if (!result) return;
                      setIsLoading(true);
                      if (await sendUpdatePasswordMail(admin.email)) {
                        setToastText("パスワード再設定メールを送信しました");
                      } else {
                        setToastText("パスワード再設定メールを送信中にエラーが発生しました");
                      }
                      setIsLoading(false);
                      setToastOpen(true);
                    },
                    children: "\u30D1\u30B9\u30EF\u30FC\u30C9\u5909\u66F4"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_base.Button, {
                    ...stylex.props(_Style.buttonStyle.secondary),
                    onClick: async () => {
                      if (!window.confirm('管理者「' + admin.name + '」を削除してもよろしいですか？')) return;
                      setIsLoading(true);
                      const deleteResult = await deleteAdmin(admin.id);
                      setIsLoading(false);
                      if (!deleteResult) {
                        setToastText('削除中にエラーが発生しました');
                        setToastOpen(true);
                        return;
                      }
                      setToastText('管理者「' + admin.name + '」を削除しました');
                      setToastOpen(true);
                    },
                    children: "\u7BA1\u7406\u8005\u60C5\u5831\u3092\u524A\u9664"
                  })]
                })
              })]
            });
          })
        })]
      })
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      ...stylex.props(_Style.textStyle.p1b),
      children: errors.list || '該当する管理者が存在しません'
    })]
  });
};
var _default = exports.default = App;